import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Button from '@atlaskit/button/standard-button';
export default function Navigator(props) {
  return /*#__PURE__*/React.createElement(Button
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  , _extends({}, props, {
    appearance: "subtle"
  }));
}